const linksEn = {
  "admin.links.text0": "Unable to load links.",
  "admin.links.text1": "Link disabled.",
  "admin.links.text2": "Link reactivated.",
  "admin.links.text3": "Short links",
  "admin.links.text4": "All links created on the service",
  "admin.links.text5": "All short links",
  "admin.links.text6": "Overview of links created by accounts. An abusive link can be disabled immediately.",
  "admin.links.text7": "Refresh",
  "admin.links.text8": "Search (code, destination, email)",
  "admin.links.text9": "No links.",
  "admin.links.text10": "Protected",
  "admin.links.text11": "Disabled",
  "admin.links.text12": "click",
  "admin.links.text13": "Enable or disable the link",
  "admin.links.text14": "Active",
  "admin.links.text15": "Link copied.",
  "admin.links.text16": "Copy",
  "admin.links.text17": "/clics",
  "admin.links.text18": "Click details",
  "admin.links.text19": "7 days",
  "admin.links.text20": "30 days",
  "admin.links.text21": "90 days",
  "admin.links.text22": "All",
  "admin.links.text23": "Unable to load click details.",
  "admin.links.text24": "Complete click log and grouping by visitor",
  "admin.links.text25": "Back to links",
  "admin.links.text26": "Include bots",
  "admin.links.text27": "Bots included",
  "admin.links.text28": "Log",
  "admin.links.text29": "Visitors",
  "admin.links.text30": "Every click",
  "admin.links.text31": "No clicks in this period",
  "admin.links.text32": "Search (IP, country, visitor, email)",
  "admin.links.text33": "No clicks.",
  "admin.links.text34": "Bot",
  "admin.links.text35": "Private browsing",
  "admin.links.text36": "Unknown device",
  "admin.links.text37": "Source:",
  "admin.links.text38": "Visitor:",
  "admin.links.text39": " · verified",
  "admin.links.text40": "Group by visitor",
  "admin.links.text41": "One visitor = one Fingerprint identifier (otherwise a local fingerprint or IP).",
  "admin.links.text42": "No visitors.",
  "admin.links.text43": "confidence",
  "admin.links.text44": "Unknown country",
  "admin.links.text45": "IP:",
  "admin.links.text46": "Search (IP, country, link, visitor, email)",
  "admin.links.text47": "Click log",
  "admin.links.text48": "Who clicked the links",
  "admin.links.text49": "One visitor = one Fingerprint identifier (otherwise a local fingerprint or IP). Click to see the full profile.",
  "admin.links.text50": "No clicks in this period.",
  "admin.links.text51": "Verified Fingerprint",
  "admin.links.text52": "click(s) in this period",
  "admin.links.text53": "Visitor profile: clicked links, page views, devices and detected signals",
  "admin.links.text54": "Unable to read:",
  "admin.links.text55": "No data.",
  "admin.links.text56": "Verified identifiers",
  "admin.links.text57": "Confidence (latest event)",
  "admin.links.text58": "No attribution: no authenticated sign-in proven here",
  "admin.links.text59": "Proven account",
  "admin.links.text60": " proven accounts (shared browser or workstation)",
  "admin.links.text61": "proof(s)",
  "admin.links.text62": " · latest on ",
  "admin.links.text63": "Accounts remain separate: no grouping is inferred from this coexistence.",
  "admin.links.text64": "latest event dated",
  "admin.links.text65": "Identification request:",
  "admin.links.text66": "Detailed fingerprint signals",
  "admin.links.text67": ": detailed data cannot be reconstructed afterwards. The IP address, device and page views remain available.",
  "admin.links.text68": "Identifiers observed in these events (",
  "admin.links.text69": "One IP address can include several browsers: each identifier is counted separately, and none is presented as the identity of the entire IP.",
  "admin.links.text70": "Known IP addresses",
  "admin.links.text71": "Clicked links (",
  "admin.links.text72": "No clicks recorded.",
  "admin.links.text73": " · request ",
  "admin.links.text74": "Page views (",
  "admin.links.text75": "No associated page views.",
  "admin.links.text76": "Details not found for this event.",
  "admin.links.text77": "Loading signals…",
  "admin.links.text78": "Error:",
  "admin.links.text79": "No verified observation recorded for this identifier. Older events were not identified on the server and cannot be reconstructed.",
  "admin.links.text80": "Latest verified event:",
  "admin.links.text81": "· recorded",
  "admin.links.text82": "observation(s)",
  "admin.links.text83": "Historical event displayed:",
  "admin.links.text84": "request",
  "admin.links.text85": "suspicion score (raw):",
  "admin.links.text86": "Complete table",
  "admin.links.text87": "Products JSON",
  "admin.links.text88": "event(s) displayed out of",
  "admin.links.text89": "Load the",
  "admin.links.text90": "previous",
  "admin.links.text91": "loading details…",
  "admin.links.text92": "sources:",
  "admin.links.text93": "Error loading details:",
  "admin.links.text94": "Loading signals for the selected event… (the signals shown below never belong to another event)",
  "admin.links.text95": "mobile signal",
  "admin.links.text96": "value read from",
  "admin.links.text97": "Velocity windows",
  "admin.links.text98": "VPN · confidence",
  "admin.links.text99": "origin time zone:",
  "admin.links.text100": "origin country:",
  "admin.links.text101": "Changes between observations",
  "admin.links.text102": "Complete signals table",
  "admin.links.text103": "Search a field or value…",
  "admin.links.text104": "field(s) · event on",
  "admin.links.text105": "· source",
  "admin.links.text106": "Field",
  "admin.links.text107": "Value",
  "admin.links.text108": "Product",
  "admin.links.text109": "Exclusion undone",
  "admin.links.text110": "Select at least 2 fingerprints.",
  "admin.links.text111": "Exclusion undone.",
  "admin.links.text112": "Observation not found for this proof.",
  "admin.links.text113": "Loading groups…",
  "admin.links.text114": "Associated accounts (authenticated sign-in)",
  "admin.links.text115": "No associated account: this browser has never proven an authenticated sign-in.",
  "admin.links.text116": "Several accounts signed in from this browser: it is probably a shared browser. Accounts remain separate and are never merged.",
  "admin.links.text117": "Undo exclusion",
  "admin.links.text118": "Exclude",
  "admin.links.text119": "first association",
  "admin.links.text120": "· latest",
  "admin.links.text121": "proofs:",
  "admin.links.text122": "Open the full observation for this proof",
  "admin.links.text123": "of",
  "admin.links.text124": "Previous",
  "admin.links.text125": "Next",
  "admin.links.text126": "Exclusion log",
  "admin.links.text127": "No exclusions recorded for this browser.",
  "admin.links.text128": "· account:",
  "admin.links.text129": "· reason:",
  "admin.links.text130": "· by",
  "admin.links.text131": "Same account · other browsers",
  "admin.links.text132": "No other proven browser for these accounts.",
  "admin.links.text133": "Similar fingerprints (90 days, no automatic grouping)",
  "admin.links.text134": "No similar fingerprint in this period.",
  "admin.links.text135": "matching family/families",
  "admin.links.text136": "event(s) · latest",
  "admin.links.text137": "Detailed evidence",
  "admin.links.text138": "matches:",
  "admin.links.text139": "· missing information:",
  "admin.links.text140": "devices:",
  "admin.links.text141": "· languages:",
  "admin.links.text142": "· network time zone:",
  "admin.links.text143": "· declared origin time zone:",
  "admin.links.text144": "· IP:",
  "admin.links.text145": "· links:",
  "admin.links.text146": "shared browser(s) (informational, not counted in the score):",
  "admin.links.text147": "page",
  "admin.links.text148": "Previous",
  "admin.links.text149": "Next",
  "admin.links.text150": "Side-by-side comparison (2 to 4 fingerprints, similar or not)",
  "admin.links.text151": "Add a browser identifier…",
  "admin.links.text152": "Add",
  "admin.links.text153": "Compare selection (",
  "admin.links.text154": "Clue",
  "admin.links.text155": "Network time zone (IP)",
  "admin.links.text156": "Declared origin time zone",
  "admin.links.text157": "Links viewed",
  "admin.links.text158": "Proven accounts",
  "admin.links.text159": "Request identifiers",
  "admin.links.text160": "Events",
  "admin.links.text161": "No verified event in this period:",
  "admin.links.text162": "Evidence for the match",
  "admin.links.text163": "Differences and missing data",
  "admin.links.text164": "Sign-in proof observation",
  "admin.links.text165": "account:",
  "admin.links.text166": "· request:",
  "admin.links.text167": "Loading observation…",
  "admin.links.text168": "Exclude association",
  "admin.links.text169": "Account:",
  "admin.links.text170": ". The exclusion is reversible and recorded in the log.",
  "admin.links.text171": "Reason (optional)",
  "admin.links.text172": "Cancel",
  "admin.links.text173": "No identifier in these events",
  "admin.links.text174": "Fingerprint identifier(s) ·",
  "admin.links.text175": "verified",
  "admin.links.text176": " event(s)",
  "admin.links.text177": "VPN",
  "admin.links.text178": "Proxy",
  "admin.links.text179": "Tor",
  "admin.links.text180": "No identification received",
  "admin.links.text181": "Verification not configured",
  "admin.links.text182": "Verification error",
  "admin.links.text183": "Verification unreachable",
  "admin.links.text184": "Verification timed out",
  "admin.links.text185": "Stale identification",
  "admin.links.text186": "Unusable response",
  "admin.links.text187": "Identified in browser, not verified",
  "admin.links.text188": "Browser key missing",
  "admin.links.text189": "Agent not loaded in browser",
  "admin.links.text190": "Identification failed in browser",
  "admin.links.text191": "Identification timed out in browser",
  "admin.links.text192": "Browser without request identifier",
  "admin.links.text193": "Unknown state",
  "admin.links.text194": "detected",
  "admin.links.text195": "not detected",
  "admin.links.text196": "not provided for this event",
  "admin.links.text197": "Network",
  "admin.links.text198": "Activity",
  "admin.links.text199": "Device",
  "admin.links.text200": "Bot (botd)",
  "admin.links.text201": "Spoofed location",
  "admin.links.text202": "Man-in-the-middle attack",
  "admin.links.text203": "Proximity",
  "admin.links.text204": "Browser tampering",
  "admin.links.text205": "Developer tools",
  "admin.links.text206": "Cloned application",
  "admin.links.text207": "Factory reset",
  "admin.links.text208": "Velocity",
  "admin.links.text209": "High activity",
  "admin.links.text210": "Emulator",
  "admin.links.text211": "Jailbroken device",
  "admin.links.text212": "Privacy settings",
  "admin.links.text213": "Detected",
  "admin.links.text214": "Not detected",
  "admin.links.text215": "Provider error",
  "admin.links.text216": "Provided",
  "admin.links.text217": "Not provided for this event",
  "admin.links.text218": "Browser identifier",
  "admin.links.text219": "Request identifier",
  "admin.links.text220": "Previously known browser",
  "admin.links.text221": "Confidence",
  "admin.links.text222": "First seen",
  "admin.links.text223": "Last seen",
  "admin.links.text224": "Browser",
  "admin.links.text225": "Browser version",
  "admin.links.text226": "Operating system",
  "admin.links.text227": "Operating system version",
  "admin.links.text228": "City",
  "admin.links.text229": "Country",
  "admin.links.text230": "Regions",
  "admin.links.text231": "Accuracy radius",
  "admin.links.text232": "Network (ASN)",
  "admin.links.text233": "Network range",
  "admin.links.text234": "Data center",
  "admin.links.text235": "Page",
  "admin.links.text236": "Tag",
  "admin.links.text237": "Linked identifier",
  "admin.links.text238": "Result",
  "admin.links.text239": "Anti-detect browser",
  "admin.links.text240": "Model score",
  "admin.links.text241": "Details",
  "admin.links.text242": "Today's requests",
  "admin.links.text243": "Declared origin country",
  "admin.links.text244": "Methods",
  "admin.links.text245": "Unknown account",
  "admin.links.text246": "unknown",
  "admin.links.text247": "Tampering",
  "admin.links.text248": "Virtual machine",
  "admin.links.text249": "Identification",
  "admin.links.text250": "Risk",
  "admin.links.text251": "Other products",
  "admin.links.text252": "IP information",
  "admin.links.text253": "Blocklisted IP",
  "admin.links.text254": "Suspicion score",
  "admin.links.text255": "Frida",
  "admin.links.text256": "Root applications",
  "admin.links.text257": "Device attributes",
  "admin.links.text258": "IP address",
  "admin.links.text259": "User agent",
  "admin.links.text260": "Time zone",
  "admin.links.text261": "Name",
  "admin.links.text262": "Latitude",
  "admin.links.text263": "Longitude",
  "admin.links.text264": "Postal code",
  "admin.links.text265": "Anomaly score",
  "admin.links.text266": "[unreadable value]",
  "admin.links.text267": "not provided",
  "admin.links.text268": "Exclusion",
  "admin.links.text269": "Association",
  "admin.links.text270": "Clicks",
  "admin.links.text271": "Link clicks",
  "admin.links.text272": "Page views",
  "admin.links.text273": "IP addresses",
  "admin.links.text274": "Distinct visitors",
  "admin.links.text275": "Humans",
  "admin.links.text276": "Bots",
  "admin.links.text277": "Recognized accounts",
  "admin.links.text278": "7 d",
  "admin.links.text279": "30 d",
  "admin.links.text280": "90 d",
  "admin.links.text281": "12 months",
  "admin.links.text282": "excluded",
  "admin.links.text283": "Clicks for /{v0}",
  "admin.links.text284": "From {v0} to {v1}",
  "admin.links.text285": " · confidence {v0}%",
  "admin.links.text286": "{v0} proven accounts (shared browser or workstation)",
  "admin.links.text287": " · latest on {v0}",
  "admin.links.text288": "{v0} proof(s)",
  "admin.links.text289": " · reason : {v0}",
  "admin.links.text290": "Compare {v0}",
  "admin.links.text291": " · {v0} local (bv_)",
  "admin.links.text292": "{v0} · {v1}{v2} · {v3} event(s)"
} as const;
export default linksEn;
